<form [formGroup]="form" class="entity-sidenav">
  <sidenav-loading *ngIf="downloadingEntry" [cover]="true" />
  <div class="entity-sidenav__details">
    <sidenav-title
      [closeFunc]="discardSaving.bind(this)"
      [title]="
        (!!isCreate
          ? 'ProjectCreator.SecondStep.sidenav.addTitle'
          : 'ProjectCreator.SecondStep.sidenav.editTitle'
        ) | translate
      "
    ></sidenav-title>
    <div class="entity-sidenav__details__wrapper">
      <div class="entity-sidenav__card mb-3">
        <div class="mb-4">
          <div class="new-select-label">{{ 'ProjectCreator.SecondStep.sidenav.documentCategory' | translate }}</div>
          <ng-select
            class="new-select w-100"
            [items]="items"
            [bindLabel]="'name'"
            [bindValue]="'value'"
            [clearAllText]="'clearAll' | translate"
            [searchable]="false"
            [clearable]="false"
            [placeholder]="'ProjectCreator.SecondStep.sidenav.documentCategory' | translate"
            [notFoundText]="'notFoundText' | translate"
            [tabIndex]="-1"
            [readonly]="loading"
            [formControlName]="EProjectEntitySidenavForm.TYPE"
          />
        </div>
        <div class="mb-4">
          <div class="new-select-label">{{ 'ProjectCreator.SecondStep.sidenav.folderName' | translate }}</div>
          <input-v2
            [errMessages]="errorMessages(EProjectEntitySidenavForm.NAME)"
            [readonly]="loading"
            [formControlName]="EProjectEntitySidenavForm.NAME"
            [placeholder]="
              (!form.get(EProjectEntitySidenavForm.NAME)?.value?.length
                ? 'ProjectCreator.SecondStep.sidenav.placeholder'
                : 'ProjectCreator.SecondStep.sidenav.name'
              ) | translate
            "
          />
        </div>
        <div class="relative mb-4">
          <quill-editor
            #editor
            [bounds]="'.quill-custom-img-size'"
            class="quill-v2 quill-custom-img-size quill-custom-matcher"
            (onEditorCreated)="editorInit($event)"
            [readOnly]="loading"
            [formControlName]="EProjectEntitySidenavForm.DESCRIPTION"
            [formats]="formats"
            [modules]="modules"
            [placeholder]="'ProjectCreator.SecondStep.sidenav.commentary' | translate"
          />
        </div>
      </div>

      <div>
        <attachment-manager-list-v2
          #attachmentsList
          [apiConfig]="
            !!details?.projectPublicFormToken && !sideData?.data?.internal
              ? { projectFormToken: details?.projectPublicFormToken }
              : {}
          "
          [uploadConfig]="!!this.entry?.id ? { id: this.entry.id, objectType: 'protocol-entry' } : null"
          [fileAttachments]="entry?.attachments || []"
          [projectId]="details?.id || null"
          [attachmentsConfig]="attachmentsConfig"
          [titleTranslationKey]="'ProjectCreator.SecondStep.sidenav.attachmentsLabel'"
        />
      </div>
    </div>
  </div>

  <div class="sticky-footer d-flex justify-content-between">
    <app-button
      [type]="'button'"
      (onClick)="cancel()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: 'ProjectCreator.SecondStep.sidenav.discard' | translate
      }"
    />

    <app-button
      [type]="'button'"
      [disabled]="loading"
      [loading]="loading"
      (onClick)="submit()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text:
          (!!isCreate
            ? 'ProjectCreator.SecondStep.sidenav.submitAdd'
            : 'ProjectCreator.SecondStep.sidenav.submitEdit'
          ) | translate
      }"
    />
  </div>
</form>
